import axios from "axios";
import { AuthenticationURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function loginGoogle(jwt: string) {
  ShowAwaiting();
  var res = await axios.post(
    AuthenticationURL + "api/login/social/google",
    {
      token: jwt,
    },
    { withCredentials: true }
  );
  HideAwaiting();
  return res.data;
}
